module.exports = __webpack_public_path__ + "img/partner.74a5dc70.svg";